module.exports = ".language{cursor:pointer}.language.selected{font-weight:bold;color:#FFE510}\n"